import Timeline from './Timeline';

export default ({ timeline, initialAnchorDate: anchorDateOverride = undefined as any | Date }) => {
  const noOp = () => {};
  const {
    bars,
    layout,
    milestones,
    shouldCompact,
    firstDate,
    totalDays,
    scaleMode,
    screaming,
    initialAnchorDate,
  } = timeline;
  let anchorDate = anchorDateOverride || initialAnchorDate;
  return (
    <Timeline
      bars={bars}
      setBars={noOp}
      firstDate={firstDate}
      setFirstDate={noOp}
      highlightWeekends={true}
      setHighlightWeekends={noOp}
      layout={layout}
      setLayout={noOp}
      milestones={milestones}
      setMilestones={noOp}
      scaleMode={scaleMode}
      setScaleMode={noOp}
      screaming={screaming}
      setScreaming={noOp}
      shouldCompact={shouldCompact}
      setShouldCompact={noOp}
      totalDays={totalDays}
      setTotalDays={noOp}
      editable={false}
      initialAnchorDate={anchorDate}
    />
  );
};
